const convertUser = (user) => {
  if (!user) return null;
  const groups = user.signInUserSession.accessToken.payload["cognito:groups"];
  return {
    email: user.attributes?.email,
    isAdmin: groups?.includes("admins"),
  };
};
export default convertUser;
